<template>
  <!-- start page title -->
  <b-row>
    <b-col cols="12">
      <div class="page-title-box">
        <div id="title-right" class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
        <h4 class="page-title">{{ title }}</h4>
      </div>
    </b-col>
  </b-row>
  <!-- end page title -->
</template>

<script lang="ts">
import type { BreadcrumbItem } from 'bootstrap-vue-next'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array<BreadcrumbItem>,
      default: () => {
        return []
      },
    },
  },
})
</script>

<style>
#title-right ol {
  padding-bottom: 0 !important;
}
</style>
